import { Error, RootState } from '@/store/types';
import axios, { AxiosError, AxiosResponse } from 'axios';
import { ActionTree } from 'vuex';
import { UserState, DataUser } from './types';

export const actions: ActionTree<UserState, RootState> = {
  get({ commit, state }): any {
    axios({
      url: '/users',
      method: 'GET',
    }).then(
      (response: AxiosResponse) => {
        const payload: UserState[] = response && response.data;
        commit('USER_SUCCESS', payload);
      },
      (error: AxiosError) => {
        const payload: Error = new Error(error);
        commit('USER_ERROR', payload);
      },
    );
  },
  add({ commit }, user: DataUser): any {
    return new Promise((resolve, reject) => {
      axios({
        url: '/users?template=3f',
        method: 'POST',
        data: user,
      }).then(
        () => {
          resolve();
        },
        (error: AxiosError) => {
          const payload: Error = new Error(error);
          commit('USER_ADD_ERROR', payload);
          reject();
        },
      );
    });
  },
  put({ commit }, user: DataUser): any {
    return new Promise((resolve, reject) => {
      axios({
        url: `/users/${user._id}`,
        method: 'PUT',
        data: user,
      }).then(
        () => {
          resolve();
        },
        (error: AxiosError) => {
          const payload: Error = new Error(error);
          commit('USER_PUT_ERROR', payload);
          reject();
        },
      );
    });
  },
  delete({ commit }, _id: string): any {
    return new Promise((resolve, reject) => {
      axios({
        url: `/users/${_id}`,
        method: 'DELETE',
      }).then(
        () => {
          resolve();
        },
        (error: AxiosError) => {
          const payload: Error = new Error(error);
          commit('USER_DELETE_ERROR', payload);
          reject();
        },
      );
    });
  },
};
